module.exports = __webpack_public_path__ + "img/gif_404.6b8ae1d0.gif";